import React, { useState } from 'react';
import { Alert, Collapse, IconButton, AlertTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PavoAnnouncementBar = (props) => {
    const [open, setOpen] = useState(true);

    const {
        severity = 'info',
        title = '',
        subtitle = '',
        startTime,
        endTime,
        dismissable = true,
    } = props;

    const now = new Date();
    const start = new Date(startTime);
    const end = new Date(endTime);

    // Only show if within time window
    const isActive = now >= start && now <= end;
    if (!isActive || !open) return null;

    return (
        <Collapse in={open}>
            <Alert
                severity={severity}
                action={
                    dismissable ? (
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    ) : null
                }
            >
                <AlertTitle sx={{ fontWeight: 'bold' }}>{title}</AlertTitle>
                {subtitle}
            </Alert>
        </Collapse>
    );
};

export default PavoAnnouncementBar;
